import React,{ Component} from 'react';
import { connect } from 'react-redux';

import styles from './styles.module.css';
import SectionTitle from '../../shared/components/SectionTitle';
import { isLoadingProductTypesList, getProductTypesList } from '../../shared/state/productTypes/selectors';
import { loadProductTypes } from '../../shared/state/productTypes/actions';
import ProductTypeCard from '../../shared/components/ProductTypeCard';
import { areProductsListLoaded } from '../../shared/state/products/selectors';
import { getEditorialData } from '../../shared/state/editorial/selectors';

class ProductsPage extends Component{
    render = () => {
        const {
            productTypesList = [], areProductsLoaded, areProductTypesLoaded,
            editorialData: {productsHeaderImage: {url: photoUrl} = {}}
        } = this.props;

        return (
            <div className={styles.main}>
                <div className={styles.productsHeader}>
                    <img src={photoUrl}/>
                </div>

                <div className={styles.productsWrapper}>
                    <SectionTitle 
                        center={false}
                        title={'Produtos'}/>
                    
                    <div className={styles.productsDescription}>
                        { 'A Solmar Limpezas apresenta também como uma grande fornecedora de uma vaga de produtos de higiene, utilizados nos mais variados ramos da restauração e hotelaria.'}
                    </div>

                    <div className={styles.productTypesList}>

                    {
                        areProductTypesLoaded && areProductsLoaded ? 
                            productTypesList.filter(({products=[]}) => products.length).map((productType, i) => (
                                <ProductTypeCard 
                                    key={i}
                                    productType={productType}/> 
                            ))
                        : null
                    }
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = () => {
    return (state) => ({
        areProductTypesLoaded: areProductsListLoaded(state),
        areProductsLoaded: areProductsListLoaded(state),
        productTypesList: getProductTypesList(state),
        editorialData: getEditorialData(state)
    });
};

export default connect(mapStateToProps)(ProductsPage);